import $ from "jquery";

$(function() {
    $(".bl-textwithcircleanim").each(function() {
        const $bl = $(this);
        initVideoPlayer($bl);
    });
});

function initVideoPlayer($bl)
{
    //setup observer
    const options = {
        root: null, //null=window
        rootMargin: "0% 0% -25% 0%", //unten -25%
        threshold: 0 //triggert, wenn Element zu 0% sichtbar (innerhalb rootMargin) => 0% = triggert sofort, wenn nur ein bisschen sichtbar. Noetig fuer grosse Elemente.
    };

    const observer = new IntersectionObserver(handleVideoIntersect, options);

    $bl.find("video").each(function() {
        const $video = $(this);
        const video = $video.get(0);

        observer.observe(video);
    });
}


function handleVideoIntersect(entries, observer) {
    entries.forEach((entry) => {
        if(entry.isIntersecting) {
            const video = entry.target;
            observer.unobserve(entry.target);

            startVideo(video);
        }
    });
}

function startVideo(video) {
    video.play();
}